const platformComponents = {
  aggregation: {
    id: 'aggregation',
    title: 'Vue Finance - Data Aggregation',
    description: 'Vue Finances was engineered to pull values from the source of your financial data. This eliminates the need to aggregate data manually and provides you with a seamless way to visualize your portfolio.',
    icon: 'ios-ionic-outline',
    color: '#42368D',
    backgroundColor: 'linear-gradient(rgb(66, 54, 141), rgb(63, 53, 125))',
    // backgroundColor: '#2c3849',
    route: 'Data Aggregation',
    card: {
      title: 'Data Aggregation',
      description: 'We do the work of aggregating the values needed to generate your net-worth and value your assets.',
    },
    sectionNavigation: {
      next: {
        id: 'valuations',
        title: 'Asset Valuations',
        content: 'Now that you’ve pulled in the data you need, generate valuation for your assets and calculate your net worth.',
      },
      prev: {
        id: 'assessments',
        title: 'Dynamic Assessments',
        content: 'Learn how you can use your connected data to generate actionable financial reports.',
      },
    },
    problem: {
      title: 'Your Financial Data is Scattered',
      descriptions: [
        'As your portfolio grows, so does the difficulty of aggregating your finances. Even calculating your net worth can become a complex, time-intensive process when your financial information is widespread.',
      ],
      image: '/static/aggregation-2.png',
    },
    solution: {
      title: 'We Bring it All Together',
      descriptions: [
        'Utilizing the data from financial institutions, valuation services, account management systems and more, we source everything you need to better understand your finances. Once connected, our system seamlessly pulls data and presents it to you in a way that\'s easy to understand.',
      ],
      image: '/static/aggregation-3.png',
    },
    demo: {
      title: 'What you can do with Data Aggregation',
      sections: [
        {
          title: 'See all of your bank accounts in one place',
          descriptions: [
            'We integrate with over 14,000 financial institutions so you can see checking, brokerage, retirement, and trading, accounts all in one location.',
          ],
          image: '/static/connect-accounts.png',
        },
        {
          // title: 'Sync your financial data to and from your spreadsheets',
          title: 'Import values for your real estate portfolio',
          descriptions: [
            'Import the value of properties to see your real estate portfolio alongside your personal finances. Don\'t worry, if you own real estate through an LLC or trust, you specify its ownership.',
          ],
          image: '/static/zillow-import.png',
        },
        {
          title: 'Use any of our constantly growing list of integrations',
          descriptions: [
            'We\'re constantly building new integrations to help you visualize values for your real estate, businesses, crypto currencies, and more.',
          ],
          image: '/static/integrations.png',
        },
      ],
    },
  },
  valuations: {
    id: 'valuations',
    title: 'Vue Finance - Asset Valuations',
    description: 'Our software provides you with an instant and accurate valuation for each of your assets. You can now track the value of your assets with high precision and minimal effort.',
    icon: 'ios-settings',
    color: '#0F3D7E',
    backgroundColor: 'linear-gradient(rgb(16, 66, 138), rgb(15, 57, 115))',
    // backgroundColor: '#2c3849',
    route: 'Asset Valuations',
    image: null,
    card: {
      title: 'Asset Valuations',
      description: 'Define how to valuate your assets and we’ll do the number-crunching.',
    },
    sectionNavigation: {
      next: {
        id: 'assessments',
        title: 'Custom Assessments',
        content: 'Now that you can valuate your assets, create assessments to visualize your portfolio.',
      },
      prev: {
        id: 'aggregation',
        title: 'Data Aggregation',
        content: 'Connect to the source of your financial information to better valuate your net worth and assets.',
      },
    },
    problem: {
      title: 'Valuations on Autopilot',
      descriptions: [
        'Vue Finance eliminates the need to manually calculate the value of your assets and net worth.',
        'Define a formula (or "expression") for any asset in your portfolio and we\'ll take care of the rest, providing you with valuations for each asset, on-demand.',
      ],
      image: '/static/valuations-1.png',
    },
    solution: {
      title: 'Customizable & Extensible',
      descriptions: [
        'Utilize the value of other assets, and imported values from external resources, to seamlessly generate the worth of complex assets. Proven to be useful for valuating businesses and real estate.',
      ],
      image: '/static/valuations-2.png',
    },
    demo: {
      title: 'What you can do with Valuations',
      sections: [
        {
          title: 'Nest Accounts under an entity',
          descriptions: [
            'Specify an account\'s ownership to gain a true view of ownership and liability across your portfolio. Use the "Sum of Accounts" valuation to generate a value for the parent entity.',
          ],
          image: '/static/nested-accounts-with-formulas.png',
        },
        {
          title: 'Create and track custom values ',
          descriptions: [
            'Create custom values that stay up-to-date and always accurate. You can use these values in your Assessments to create reports and insights.',
          ],
          image: '/static/custom-values.png',
        },
      ],
    },
  },
  assessments: {
    id: 'assessments',
    title: 'Vue Finance - Dynamic Assessments',
    description: 'We\'ve developed a better way for you to visualize your finances. Use Assessments to create custom and personalized reports to uncover the insights needed to grow your net worth.',
    icon: 'ios-pie-outline',
    color: 'rgb(27, 162, 142)',
    backgroundColor: 'linear-gradient(rgb(27, 162, 142), rgb(23, 148, 129))',
    // backgroundColor: 'linear-gradient(rgb(22, 112, 99), rgb(32, 92, 82)) 0% 0% / cover',
    // color: 'rgb(43, 168, 150)',
    // backgroundColor: 'linear-gradient(rgb(43, 168, 150), rgb(23, 148, 129))',
    route: 'Dynamic Assessments',
    // image: '/static/assessments-hero.png',
    card: {
      title: 'Dynamic Assessments',
      description: 'Create custom reports and assessments that help grow your net-worth.',
    },
    sectionNavigation: {
      next: {
        id: 'aggregation',
        title: 'Data Aggregation',
        content: 'Connect to the source of your financial information to create more accurate and relevant assessments.',
      },
      prev: {
        id: 'valuations',
        title: 'Asset Valuations',
        content: 'Use Asset Valuations to calculate the value of your assets and build more robust reports.',
      },
    },
    problem: {
      // 'You need anwers'
      title: 'You Have Questions...',
      descriptions: [
        'Before you can make an investment, redistribute your portfolio, or make any other imporant financial decision, you need to have a clear picture of your finances and know where you stand.',
        'What is your porfolio distribution? How much cash do you have on hand? Which assets are contributing the most to your net worth? Is your investment strategy paying off?',
      ],
      image: '/static/assessments-1.png',
    },
    solution: {
      title: 'We Provide Answers',
      descriptions: [
        'With a click of a button you can dive deep into your financial data and uncover the insights you need to make confident, data-driven financial descisions.',
        'Build reports that are relevant and imporant to you. Once created, your assessments stay up to date with the source of your financial information and are accessible where and when you need it most.',
      ],
      image: '/static/assessments-2.png',
    },
    demo: {
      title: 'What you can do with Assessments',
      sections: [
        {
          // title: 'Sync your financial data to and from your spreadsheets',
          title: 'See your portfolio distribution',
          descriptions: [
            'Once all of your portfolio values are imported, you can use pie charts to visualize your portfolio distribution and more.',
          ],
          component: 'PortfolioDistCard',
        },
        {
          title: 'Track your net worth over time',
          descriptions: [
            'Use change indicators to see the percent change of a value given a time period, for example your net worth over a month or year.',
          ],
          component: 'NetWorthIndicator',
        },
        {
          title: 'Compare the performance of multiple investments',
          descriptions: [
            'Use line charts to see any value in your portfolio over time. In this case, comparing the ROI of two investment sectors in your portfolio.',
          ],
          component: 'REvMarketCard',
        },
      ],
    },
  },
  /*eslint-disable */
  // support: {
  //   id: 'support',
  //   title: 'Vue Finance - Hands on Support',
  //   description: '',
  //   icon: 'help-buoy',
  //   color: '#257D77',
  //    backgroundColor: 'linear-gradient(#257D77, #257D77)',
  //   route: 'Hands-on Support',
  //   image: '/static/hands-on-support-hero.png',
  //   card: {
  //     title: 'Hands-on Support',
  //     description: 'Have a team of Solution Engineers by your side helping you configure your portfolio and create in-depth reports.',
  //   },
  // },
};

export default platformComponents;



// WEBPACK FOOTER //
// ./src/services/pages.js